/**
 * The rule `app/v1/seo_content._require_page_on_site` applies, checked before
 * the request goes out: https, on this site's domain or a subdomain of it.
 * Empty is fine — it means a new article.
 */
export function rewriteUrlError(value: string, domain: string): string | undefined {
  const trimmed = value.trim()
  if (trimmed === '') return undefined
  let parsed: URL
  try {
    parsed = new URL(trimmed)
  } catch {
    return `A full address, starting https://${domain}/.`
  }
  const host = parsed.hostname.toLowerCase()
  const wanted = domain.toLowerCase()
  if (parsed.protocol !== 'https:' || !(host === wanted || host.endsWith(`.${wanted}`))) {
    return `Only a page on ${domain} can be rewritten.`
  }
  return undefined
}
